import { Box, Button, IconButton, Tooltip } from "@mui/material"
import CloseIcon from '@mui/icons-material/Close'
import { updateCoords, toggleQuestionable } from "../supabaseApi"
import { resetBox } from "../zoomChecker"
import { t } from '../utils/strings'
import { trackEvent } from '../utils/analytics'

const PositionPrompt=({x,
                        y,
                        v,
                        authData,
                        fetchData,
                        mapRef,
                        handleItemToPosition,
                        handleRightPanel,
                        handleItemsToeEdit,
                        item,
                        lngLat,
                        handlePositionPromptOpen,
                        handleItemsToMark,
                        handleMarkedThumbnail,
                        angle,
                        setLastGeotaggedId,
                        geotagSourcePanel,
                        lang
                    })=>{
        console.log(item)

    const handleSubmit = async (markQuestionable) => {
        console.log('PositionPrompt submit - item:', item?.id, 'lngLat:', lngLat, 'angle:', angle, 'userId:', authData?.user?.id)
        try {
            await updateCoords(item.id, lngLat.lat, lngLat.lng, angle, authData?.user?.id)
        } catch(err) {
            console.error('updateCoords ERROR:', err)
            alert(t('saveError', lang, { error: err?.message || 'Unknown error' }))
            return
        }
        if (markQuestionable && authData?.user?.id) {
            try {
                await toggleQuestionable(item.id, authData.user.id)
            } catch(err) {
                console.error('toggleQuestionable ERROR:', err)
            }
        }
        trackEvent('geotag_confirmed', { item_id: item.id, metadata: { questionable: !!markQuestionable } })
        handlePositionPromptOpen()
        handleItemsToMark([])
        handleItemsToeEdit([])
        resetBox()
        fetchData(mapRef.getBounds(), true)
        setLastGeotaggedId(item.id)
        handleItemToPosition(null)
        handleMarkedThumbnail(null)
        if (geotagSourcePanel?.current !== null) {
            handleRightPanel(geotagSourcePanel.current)
            geotagSourcePanel.current = null
        }
    }

    const handleClose = () => {
        handleItemToPosition(null)
        handleItemsToMark([])
        handlePositionPromptOpen()
        if (geotagSourcePanel?.current !== null) {
            handleRightPanel(geotagSourcePanel.current)
            geotagSourcePanel.current = null
        }
    }

    return <Box sx={{position:'absolute',top:y+'px',left:x+'px', width:'200px',zIndex:3,backgroundColor:'white',padding:'8px 12px 12px'}}>
        <div style={{display:'flex',justifyContent:'flex-end'}}>
            <IconButton size="small" onClick={handleClose}>
                <CloseIcon fontSize="small" />
            </IconButton>
        </div>
        <div style={{display:'flex',flexDirection:'column',gap:'6px'}}>
            <Button variant="contained" size="small" sx={{textTransform:'none'}} onClick={() => handleSubmit(false)}>{t('confirm', lang)}</Button>
            <Tooltip title={t('saveSuggestUncertain', lang)}>
                <Button variant="contained" size="small" sx={{textTransform:'none', color:'white', backgroundColor:'#ff9800', '&:hover':{backgroundColor:'#e68a00'}}} onClick={() => handleSubmit(true)}>{t('suggestOnly', lang)}</Button>
            </Tooltip>
        </div>
    </Box>

}

export default PositionPrompt
